import dayjs from 'dayjs'

export interface TrendDatePoint {
    date: string
    count: number
}

export const filterTrendDataByMaxDate = <T extends TrendDatePoint>(
    items: T[],
    maxDate?: string | null
): T[] => {
    const cutoffDate = maxDate ? dayjs(maxDate) : null
    if (!cutoffDate?.isValid()) {
        return items
    }

    return items.filter((item) => {
        const itemDate = dayjs(item.date)
        return itemDate.isValid() && !itemDate.isAfter(cutoffDate, 'day')
    })
}
